module.exports = __webpack_public_path__ + "static/media/37.2be1008d.mp3";